import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';
import DialogsWithIcon from '../DialogsWithIcon';

import './DialogWithInfoLayout.scss';

export default function DialogWithNotificationInfoLayout(props) {
  const { character = '!', children, selfClose, onYesClick, footerClassName, yesLabel = 'OK' } = props;

  const clickHandler = () => {
    selfClose();
    if (onYesClick) {
      onYesClick();
    }
  };

  return (
    <DialogsWithIcon
      {...props}
      character={character}
      layoutType="info"
      headerClassName="dialog-with-info-layout-header"
      footerClassName={classnames(footerClassName, 'dialog-with-info-layout-footer-wrapper')}
      footer={
        <div>
          <ButtonWithIcon
            data-e2e="dialog-ok"
            type="primary"
            size="small"
            sprite="ChevronRight"
            iconRight
            onClick={clickHandler}
            className="e2e-dialog-ok">
            {yesLabel}
          </ButtonWithIcon>
        </div>
      }>
      {children}
    </DialogsWithIcon>
  );
}

DialogWithNotificationInfoLayout.propTypes = {
  selfClose: PropTypes.func.isRequired,
  onYesClick: PropTypes.func,
  yesLabel: PropTypes.string,
  character: PropTypes.string,
  children: PropTypes.node,
};
